import { IMPORT_POI, ERROR_IMPORT } from '../actions/types';

export default function postReducer(state = {data: [], warnings:[]}, action) {
    switch (action.type) {
        case IMPORT_POI:
            return action.payload;
        case ERROR_IMPORT:
            return action.payload;
        default:
            return state;
    }
}